'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct9 from "./scala.-Product9.js";
var $p;
/** @constructor */
function $c_T9(_1, _2, _3, _4, _5, _6, _7, _8, _9) {
  this.qd = null;
  this.qe = null;
  this.qf = null;
  this.qg = null;
  this.qh = null;
  this.qi = null;
  this.qj = null;
  this.qk = null;
  this.ql = null;
  this.qd = _1;
  this.qe = _2;
  this.qf = _3;
  this.qg = _4;
  this.qh = _5;
  this.qi = _6;
  this.qj = _7;
  this.qk = _8;
  this.ql = _9;
}
export { $c_T9 as $c_T9 };
$p = $c_T9.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T9;
/** @constructor */
function $h_T9() {
}
export { $h_T9 as $h_T9 };
$h_T9.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 9;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct9.$f_s_Product9__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-1807911176), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T9) && (((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qd, x$0.qd) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qe, x$0.qe)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qf, x$0.qf)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qg, x$0.qg)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qh, x$0.qh)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qi, x$0.qi)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qj, x$0.qj)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qk, x$0.qk)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ql, x$0.ql))));
});
$p.o = (function() {
  return "Tuple9";
});
$p.b = (function() {
  return (((((((((((((((((("(" + this.qd) + ",") + this.qe) + ",") + this.qf) + ",") + this.qg) + ",") + this.qh) + ",") + this.qi) + ",") + this.qj) + ",") + this.qk) + ",") + this.ql) + ")");
});
function $isArrayOf_T9(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eT)));
}
export { $isArrayOf_T9 as $isArrayOf_T9 };
var $d_T9 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T9, "scala.Tuple9", ({
  eT: 1,
  b: 1,
  c: 1,
  s2: 1,
  a: 1
}));
export { $d_T9 as $d_T9 };
